interface Action {
    payload: any,
    type: string
}

export const GET_DEPARTMENTS = 'GET_DEPARTMENTS',
             RESET_DEPARTMENTS = 'RESET_DEPARTMENTS',
             GET_DEPARTMENTS_ERROR = 'GET_DEPARTMENTS_ERROR';

const DepartmentsReducer = (state = [], action: Action) => {
    switch (action.type) {
        case GET_DEPARTMENTS:
            return action.payload;
        case RESET_DEPARTMENTS:
            return [];
        default:
            return state;
    }
};

export default DepartmentsReducer;
